export const ur = {
    "n1": "ہوم پیج",
    "n2": "آرڈر",
    "n3": "لین دین",
    "n4": "ٹیم",
    "n5": "میرا",
    "t1": "کچھ غلط ہو گیا",
    "t2": "کامیابی کے ساتھ کاپی کیا",
    "t3": "براہ کرم معلومات کو مکمل طور پر پُر کریں",
    "t4": "لوڈنگ...",
    "t5": "لاگ ان کامیاب",
    "t6": "اسکور جمع کرانے کے لئے 3 سے زیادہ ہونا چاہئے",
    "t7": "جمع کروانا کامیاب",
    "t8": "ناکافی توازن ، وصول کرنے سے قاصر ہے",
    "t9": "پیش کرنے میں ناکام رہا",
    "t10": "براہ کرم پہلے انخلا کا پتہ باندھیں",
    "t11": "پتہ پابند ہے ، براہ کرم اس میں ترمیم کرنے کے لئے کسٹمر سروس سے رابطہ کریں۔",
    "t12": "ترمیم کامیاب",
    "t13": "ترمیم ناکام ہوگئی",
    "t14": "براہ کرم اپنا پاس ورڈ تبدیل کرنے کے لئے کسٹمر سروس سے رابطہ کریں",
    "t15": "پاس ورڈ کی شکل میں خرابی",
    "t16": "کامیابی سے دستبردار ہوجائیں",
    "t17": "زیادہ سے زیادہ رقم جسے واپس لیا جاسکتا ہے",
    "t18": "کم سے کم انخلا",
    "t19": "دو پاس ورڈ متضاد ہیں",
    "t20": "اشارے",
    "t21": "اس وقت کودنے سے قاصر ہے",
    "t22": "پاس ورڈ کی شکل میں خرابی",
    "t23": "رجسٹریشن کامیاب",
    "t24": "براہ کرم ایریا کوڈ درج کریں",
    "t25": "مزید نہیں",
    "l1": "زبان",
    "l2": "براہ کرم اکاؤنٹ نمبر درج کریں",
    "l3": "براہ کرم پاس ورڈ درج کریں",
    "l4": "یاد رکھیں",
    "l5": "لاگ ان",
    "l6": "اندراج کے لئے جائیں",
    "l7": "کوئی اکاؤنٹ نہیں",
    "l8": "موبائل فون نمبر",
    "l9": "عرفی نام",
    "l10": "پاس ورڈ",
    "l11": "پاس ورڈ کی تصدیق کریں",
    "l12": "دعوت نامہ",
    "l13": "رجسٹر کریں",
    "l14": "پہلے سے ہی ایک اکاؤنٹ ہے",
    "l15": "لاگ ان پر جائیں",
    "l16": "براہ کرم 6-16 ہندسوں کا پاس ورڈ درج کریں",
    "bz1": "مدد",
    "bz2": "سوالات",
    "bz3": "تجارتی قواعد",
    "bz4": "پیسہ کیسے نکالا جائے",
    "bz5": "ریچارج کیسے کریں",
    "bz6": "1. ایمیزون ریویو روبوٹ کیا ہے؟",
    "bz7": "ایمیزون ریویو روبوٹ ایک مارکیٹنگ پروموشن کمپنی ہے جو دنیا بھر کے ایمیزون کے جائزے کے روبوٹ آن لائن اسٹور کے تاجروں کو مزید آرڈر کی فروخت حاصل کرنے اور ایمیزون ریویو روبوٹ آن لائن اسٹورز کے براؤزنگ ڈیٹا میں اضافہ کرنے میں مدد کرتی ہے۔ ہم ایمیزون ریویو روبوٹ ، تاجروں اور صارفین کے مابین تین پارٹی منافع بخش مارکیٹنگ اور پروموشن ماڈل قائم کرنے کے لئے پرعزم ہیں۔ جدید ترین P2P بلاکچین ٹکنالوجی کے ساتھ مل کر ، صارفین اور تاجروں کو تیزی سے یو ایس ڈی ٹی (ٹی آر سی 20 ، ای آر سی 20) کے ذریعے منسلک کیا جاتا ہے۔ رجسٹرڈ صارفین احکامات پر کمیشن حاصل کرسکتے ہیں ، جبکہ تاجر اپنے اسٹور کے فروخت کے اعداد و شمار میں اضافہ کرسکتے ہیں۔ یہ انٹرنیٹ بلاکچین ماڈل میں تازہ ترین منافع کا ماڈل ہے!",
    "bz8": "2. ایمیزون روبوٹ کے کام کا جائزہ کیسے لیتا ہے؟",
    "bz9": "ایمیزون ریویو روبوٹ کی روزانہ کی آراء سے پتہ چلتا ہے کہ ایمیزون ریویو روبوٹ میں بہتری کی ضرورت والی مصنوعات کو فروخت کیا جاتا ہے۔ صارفین کو صرف آرڈر پر آسانی سے کلک کرنے کی ضرورت ہوتی ہے ، اور سسٹم خود بخود آرڈر سبسکرپشن تیار کرتا ہے۔ صارفین بلاکچین یو ایس ڈی ٹی کے ذریعہ آرڈر کی رقم ادا کرتے ہیں اور روزانہ کمیشن وصول کرتے ہیں۔",
    "bz10": "3. ایک ہی کرنسی کی قیمتیں دو لین دین میں کیوں مختلف ہیں؟",
    "bz11": "قیمت میں فرق ان تمام عوامل کی وجہ سے ہوتا ہے جو کرنسیوں کی آزاد گردش کے لئے موزوں نہیں ہیں ، جن میں کرنسی کی منتقلی کی رفتار ، نیٹ ورک کی شرائط ، کرنسی تک رسائی کی پابندی ، مختلف علاقوں میں لوگوں کے ذریعہ کرنسی کی پہچان ، اور یہاں تک کہ تبادلے ، لین دین وغیرہ کے ذریعہ فراہم کردہ تجارتی جوڑے کی اقسام بھی مختلف لین دین میں قیمتوں میں مختلف ہوسکتی ہیں۔",
    "bz12": "4. سرمایہ کاری کا منافع؟",
    "bz13": "آپ کو جس چیز کی قیمت ملتی ہے اس کی قیمت جتنی زیادہ ہوگی ، آرڈر پر آپ کو منافع اتنا ہی زیادہ ہوگا۔ ایک ہی وقت میں ، ایمیزون جائزہ روبوٹ تصادفی طور پر کمیشن کے بڑے احکامات تقسیم کرتا ہے۔",
    "bz14": "ہر روز ، سسٹم خود بخود صارفین کو 60 پروڈکٹ آرڈر تیار کرتا ہے اور تقسیم کرتا ہے۔ صارفین USDT کے ذریعہ ہر آرڈر کی ادائیگی مکمل کرتے ہیں اور 0.6 ٪ کمیشن وصول کرتے ہیں۔ کمیشن کے بڑے احکامات تصادفی طور پر تفویض کیے جاتے ہیں۔",
    "bz15": "60 احکامات کے بعد یو ایس ڈی ٹی کو واپس لیا جاسکتا ہے۔ (اگر 60 احکامات مکمل نہیں ہوئے ہیں تو ، یہ نظام خود بخود رک جائے گا جب تک کہ دن کے باقی احکامات)",
    "bz16": "ہر اکاؤنٹ میں صرف ایک یو ایس ڈی ٹی اکاؤنٹ کا پابند ہوسکتا ہے۔ اگر کوئی خرابی پیش آتی ہے تو ، براہ کرم کسٹمر سروس سے رابطہ کریں۔",
    "bz17": "روزانہ کے احکامات کی فراہمی کو مکمل کرنے کے بعد ، آپ عام طور پر پیسہ واپس لے سکتے ہیں۔ رقم انخلا شروع کرنے کے بعد 24 گھنٹوں کے اندر اندر آجائے گی ، اور انخلا کی کوئی حد نہیں ہے۔",
    "bz18": "ری چارج کرنے سے پہلے ، براہ کرم اپنا انخلا کا پتہ (TRC-20 کی حمایت کرتا ہے) USDT ایڈریس کو پابند کریں۔ آپ ایپ یا ویب پیج پر ریچارج پر کلک کرسکتے ہیں اور ریچارج کرنے کے لئے استعمال ہونے والے بلاکچین (TRC-20) کو منتخب کرسکتے ہیں۔",
    "bz19": "متعلقہ اکاؤنٹس کے مابین باہمی ریچارجز ، بینک ٹرانسفر ، ایکسچینج ٹرانسفر وغیرہ کا انعقاد کرنا ممنوع ہے۔ اس طرز عمل پر بدنیتی پر مبنی حکم پر قبضہ کرنے کا شبہ ہے۔ اگر اس طرح کا سلوک مل جاتا ہے تو ، اکاؤنٹ پر پابندی عائد کردی جائے گی۔",
    "ty1": "ٹھیک ہے",
    "ty2": "منسوخ کریں",
    "ty3": "پیش کریں",
    "ty4": "TRC20 ایڈریس",
    "ty5": "ERC20 ایڈریس",
    "s1": "مجموعی آمدنی",
    "s2": "خدمت",
    "s3": "ہمارے بارے میں",
    "s4": "مدد",
    "s5": "شراکت دار",
    "s6": "میری خدمات",
    "d1": "مکمل نہیں ہوا",
    "d2": "مکمل",
    "d3": "ابھی تک کوئی ڈیٹا نہیں ہے",
    "d4": "آرڈر نمبر",
    "d5": "تجارت کے اوقات",
    "d6": "رقم",
    "d7": "موجودہ کاموں کی تعداد",
    "d8": "متوقع واپسی",
    "d9": "پھر بھی ضرورت ہے",
    "d10": "درجہ بندی",
    "j1": "اکاؤنٹ بیلنس",
    "j2": "تجارت کا تعارف",
    "j3": "ایمیزون ریویو روبوٹ ایمیزون ریویو روبوٹ سے ہر روز آراء کا استعمال ایمیزون ریویو روبوٹ کے ذریعہ فروخت کردہ مصنوعات کی نمائش کے لئے کرتا ہے جس میں بہتری کی ضرورت ہے۔ صارفین کو صرف آرڈر پر کلک کرنے کی ضرورت ہے اور سسٹم خود بخود آرڈر کے دستخط تیار کرے گا۔ صارفین یو ایس ڈی ٹی بلاکچین کے ذریعے آرڈر کی رقم ادا کرتے ہیں اور ہر بار 0.6 فیصد سے زیادہ کمیشن وصول کرسکتے ہیں ، اور یہ نظام تصادفی طور پر بڑے انعام کے احکامات تقسیم کرتا ہے۔",
    "j4": "ملاپ شروع کریں",
    "j5": "آج کی کمائی",
    "j6": "مکمل",
    "j7": "کاموں کی کل تعداد",
    "td1": "توازن",
    "td2": "کمیشن",
    "td3": "وصول کریں",
    "td4": "لوگوں کی کل تعداد",
    "td5": "صارف",
    "td6": "شراکت کریں",
    "td7": "مقدار",
    "td8": "حیثیت",
    "g1": "نقد رقم واپس لیں",
    "g2": "ریچارج",
    "g3": "دوستوں کو مدعو کریں",
    "g4": "اب دعوت دیں",
    "g5": "آپ کے دوستوں کے اندراج کے بعد ہر منافع کے ل you ، آپ کو متعلقہ کمیشن ملے گا۔",
    "g6": "ذاتی معلومات",
    "g7": "فنڈ کی تفصیلات",
    "g8": "ریچارج ریکارڈ",
    "g9": "واپسی کے ریکارڈ",
    "g10": "زبان",
    "g11": "لاگ آؤٹ",
    "g12": "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
    "yh1": "صارف کی معلومات",
    "yh2": "ترمیم کریں",
    "yh3": "ترتیبات",
    "yh4": "فون",
    "yh6": "اصل پاس ورڈ",
    "yh7": "نیا پاس ورڈ",
    "mx1": "کمیشن کلیکشن",
    "mx2": "آمدنی",
    "mx3": "واپسی مسترد کردی گئی",
    "mx4": "وقت",
    "mx5": "ریچارج کامیاب",
    "mx6": "مسترد",
    "mx7": "زیر التوا",
    "mx8": "واپسی کا پتہ",
    "mx9": "دستیاب توازن",
    "mx10": "اصل آمد",
    "mx11": "براہ کرم انخلا کی رقم درج کریں",
    "cz1": "ڈپازٹ ایڈریس صرف ERC20 کی حمایت کرتا ہے ، اور کم سے کم جمع رقم 20USDT ہے۔",
    "cz2": "کاپی",
    "cz3": "فیاٹ کرنسی کا انتخاب",
    "cz4": "ادا کریں",
    "cz5": "ڈپازٹ ایڈریس صرف TRC20-USDT کی حمایت کرتا ہے ، اور کم سے کم جمع رقم 20USDT ہے۔",
    "cz6": "ڈپازٹ ایڈریس صرف ERC20 کی حمایت کرتا ہے ، اور کم سے کم جمع رقم 20USDT ہے۔",
    "cz10": "ڈپازٹ ایڈریس صرف بی ٹی سی کی حمایت کرتا ہے",
    "qy1": "ایریا کوڈ",
    "yq1": "دوستوں کو مدعو کریں",
    "yq2": "دعوت نامہ",
    "yq3": "دوستوں کو مدعو کریں اور بڑے فوائد سے لطف اٹھائیں",
    "yq4": "جاؤ اور دعوت دیں",
    "new1": "ادائیگی کا طریقہ",
    "zf1": "ریچارج طریقہ",
    "zf2": "براہ کرم ریچارج کا طریقہ منتخب کریں",
    "zf3": "تجارتی کرنسیوں کو",
    "zf4": "ٹریڈنگ نیٹ ورک",
    "zf5": "تجارت پر جائیں",
    "zf6": "کامیابی کے ساتھ کاپی کیا",
    "zf7": "تجارتی کرنسیوں کو",
    "zf8": "براہ کرم استعمال کریں",
    "zf9": "ریچارج کو مکمل کرنے کے لئے نیچے دیئے گئے پتے پر رقم منتقل کریں۔",
    "zf10": "ٹرانزیکشن کرنسی",
    "zf11": "کاپی",
    "zf12": "براہ کرم ایڈریس کو احتیاط سے چیک کریں۔ اگر آپ اسے غلط طریقے سے منتقل کرتے ہیں تو ، آپ اسے بازیافت نہیں کرسکیں گے۔",
    "zf13": "آمد کا وقت",
    "zf14": "تقریبا 1 ~ 5 منٹ",
    "zf15": "کم سے کم ریچارج رقم",
    "a1": "اسٹور مارکیٹنگ سینٹر",
    "a2": "ایمیزون مارکیٹ روبوٹ اسٹور مارکیٹنگ سینٹر ایک بالکل نیا سیکشن ہے جو تاجروں کو مختصر مدت میں اپنی مصنوعات کی فروخت اور تعریف کی شرحوں میں تیزی سے بڑھانے میں مدد کے لئے ڈیزائن کیا گیا ہے ، جس سے مصنوعات کا وزن بڑھتا ہے اور ان کی نمائش میں مزید اضافہ ہوتا ہے۔ صارفین مختلف کاموں کو مکمل کرکے تاجروں کی مدد کرتے ہیں اور اسی طرح کے انعامات وصول کرتے ہیں ، اس طرح دونوں فریقوں کے لئے جیت کی صورتحال کو حاصل کرتے ہیں۔",
    "a3": "اس وقت ، اس نظام میں 30 ملین صارفین اور 5 ملین تاجر ہیں ، اور پلیٹ فارم پر ہر دن ترقی یافتہ مصنوعات کی تعداد 70 ملین تک پہنچ جاتی ہے۔ کچھ مرچنٹ مصنوعات نے مارکیٹنگ سینٹر سسٹم سے رابطہ کرکے اسٹور کی فروخت میں 60 فیصد اضافہ کیا ہے۔ اور مارکیٹنگ سینٹر سسٹم کے پلیٹ فارم صارفین کو صرف آرڈر پر کلک کرنے کی ضرورت ہے ، اور مارکیٹنگ سینٹر سسٹم خود بخود آرڈر کے دستخط تیار کرے گا۔ صارف آرڈر کی رقم کی تیاری کے بعد ، ورچوئل ٹرانزیکشن مکمل ہوجاتا ہے ، اور فنڈز فوری طور پر صارف کے اکاؤنٹ میں واپس کردیئے جاتے ہیں۔ ہر بار 0.6 ٪ سے زیادہ کا ایک اضافی کمیشن حاصل کیا جاسکتا ہے۔ یہ نظام تصادفی طور پر صارف کے کمیشن کو بڑھانے کے لئے بڑے انعام کے احکامات مختص کرے گا۔",
    "a4": "ایمیزون مارکیٹ روبوٹ صارفین اور تاجروں کی ضروریات کو بہت اہمیت دیتا ہے ، اور مارکیٹنگ سینٹر کے نظام کو بہتر بنانے اور بہتر بناتا رہتا ہے۔",
    "kf1": "آن لائن سروس",
    "kf2": "دستی نکالنے کی سروس",
    "kf3": "دستی نکالنے کی سروس سے رابطہ کرنے کے لیے یہاں کلک کریں",
    "kf4": "دستی ریچارج سروس",
    "kf5": "دستی ریچارج سروس سے رابطہ کرنے کے لیے یہاں کلک کریں",
    "zf16": "بینک کارڈ ٹرانزیکشنز کے لیے براہ کرم کسٹمر سروس سے رابطہ کریں",
    "zf17": "کسٹمر سروس سے رابطہ کریں",
}
